export default {
	methods: 
    {	
		async getFiltrar()
		{
			let dataRoute={}
			let others=[]
			let filterKeys= Object.keys(this.filter);
			for (let i = 0; i < filterKeys.length; i++) {				
				if(this.filter[filterKeys[i]]!==''  && this.filter[filterKeys[i]]!==null)
				{
					if(filterKeys[i]==='id_list')
					{
						others.push([filterKeys[i],this.filter[filterKeys[i]].id ])
					}
					else 
					{
						others.push([filterKeys[i],this.filter[filterKeys[i]].name ])
					}
				}	
			}
			dataRoute.others=others
			await this.getDataGet({ route: 'get_aflpendientes', data: dataRoute})
			// frontend await this.searchGetIdb({tabla:'servicios_nuevos', campo:'name', value: this.filter.servicios[0].name, principal:'info_afiliacion'})
		},	
		async getLimpiar()
		{
			this.filter.name = null
			await this.getDataGet({ route: 'get_aflpendientes', data: {others: []}})
			// frontend await this.searchGetIdb({tabla:'servicios_nuevos',campo:'iniciolabores',value:'',principal:'info_afiliacion'})
		}
	},
}